import { gql } from '@apollo/client';

const GET_CHECK_POINT_DOCUMENT_FILE_URL = gql`
  query GetCheckPointDocumentFileUrl(
    $fileName: String!
    $checkPointId: Int!
    $isTemporary: Boolean
  ) {
    checkPointDocumentFileUrl(
      fileName: $fileName
      checkPointId: $checkPointId
      isTemporary: $isTemporary
    )
  }
`;

export default GET_CHECK_POINT_DOCUMENT_FILE_URL;
